exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".title{\r\n    margin-top:50px; \r\n    padding-left: 1px;\r\n    font-size: 22px;\r\n}\r\n\r\n@media (max-width:720px) { \r\n    .title {margin-top:20px;  }\r\n    }", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/about/privacy-policy/privacy-policy.component.css
// module id = 602
// module chunks = 8